module.exports = __webpack_public_path__ + "img/bookmark-plus_2x.d6e81306.png";